import { useEffect } from "react";
import { MapContainer, TileLayer, CircleMarker, Tooltip, Pane, useMap } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import { fmt } from "../lib/api";
import { netType } from "../lib/reports";

export const speedColor = (dl) => {
  const hue = dl <= 5 ? 0 : dl <= 10 ? ((dl - 5) / 5) * 60 : Math.min(60 + ((dl - 10) / 15) * 60, 120);
  return `hsl(${hue}, 90%, 50%)`;
};

export const HeatLayer = ({ pts, radius = 34 }) => (
  <Pane name="heat" className="heat-pane" style={{ zIndex: 410 }}>
    {pts.map((t) => (
      <CircleMarker key={`h-${t.id}`} center={[t.location.lat, t.location.lon]} radius={radius} interactive={false}
        pathOptions={{ stroke: false, fillColor: speedColor(t.download_mbps), fillOpacity: 0.55 }} />
    ))}
  </Pane>
);

export const HeatLegend = ({ className = "" }) => (
  <div className={`flex items-center gap-2 text-[10px] text-neutral-300 pointer-events-none ${className}`} data-testid="heat-legend">
    <span>Weak</span>
    <span className="flex-1 h-1.5 rounded-full" style={{ background: "linear-gradient(90deg, hsl(0,90%,50%), hsl(60,90%,50%), hsl(120,90%,50%))" }} />
    <span>Strong</span>
  </div>
);

export const FitBounds = ({ pts }) => {
  const map = useMap();
  const key = pts.map((t) => t.id).join();
  useEffect(() => {
    if (!pts.length) return;
    map.fitBounds(L.latLngBounds(pts.map((t) => [t.location.lat, t.location.lon])).pad(0.3), { maxZoom: 13 });
  }, [map, key]); // eslint-disable-line
  return null;
};

export const UserHeatMap = ({ tests }) => {
  const pts = tests.filter((t) => t.location?.lat != null);
  if (!pts.length) return null;
  return (
    <div className="relative h-[240px] rounded-2xl overflow-hidden border border-white/[0.06] mb-3" data-testid="user-heatmap">
      <MapContainer center={[pts[0].location.lat, pts[0].location.lon]} zoom={11} className="h-full w-full" zoomControl={false} attributionControl={false}>
        <TileLayer className="dark-tiles" url="https://tile.openstreetmap.org/{z}/{x}/{y}.png" />
        <FitBounds pts={pts} />
        <HeatLayer pts={pts} />
        {pts.map((t) => (
          <CircleMarker key={t.id} center={[t.location.lat, t.location.lon]} radius={5}
            pathOptions={{ color: "#fff", weight: 1.5, fillColor: speedColor(t.download_mbps), fillOpacity: 1 }}>
            <Tooltip direction="auto">
              <div className="text-[11px] leading-relaxed" style={{ fontFamily: "Outfit" }} data-testid={`user-heatmap-tooltip-${t.id}`}>
                <b>{new Date(t.created_at).toLocaleString([], { dateStyle: "short", timeStyle: "short" })}</b><br />
                {t.location.city || "—"} · {t.team}<br />
                ↓ {fmt(t.download_mbps)} · ↑ {fmt(t.upload_mbps)} Mbps<br />
                Ping {fmt(t.ping_ms, 0)}ms · Jitter {fmt(t.jitter_ms, 0)}ms<br />
                {t.isp || "Unknown"} · {netType(t)}
              </div>
            </Tooltip>
          </CircleMarker>
        ))}
      </MapContainer>
      <HeatLegend className="absolute bottom-2 left-2 right-2 z-[500]" />
    </div>
  );
};
